<template>
    <div id="go-to-redsys">
        <Header></Header>
        <!-- TO PAY -->
        <template v-if="page == 'confirm-payment'">
            <template v-if="payed < total">
                <div class="row">
                    <span>{{$t('descriptions.go_to_redsys')}}</span>
                    <span class="price">{{total}}&euro;</span>
                </div>
                <div class="row">
                    <button class="mainButton" @click="goToRedsys" >{{$t('continue')}}</button>
                </div>
            </template>
        </template>

        <!-- Payment Completed -->
        <template v-if="page == 'payment-completed'">
            <div class="success">
                {{$t('descriptions.payment-completed')}}
            </div>
        </template>

        <!-- Payment Error TPV -->
        <template v-if="page == 'error-tpv'">
            <div class="message error">
                {{$t('errors.redsys')}}
            </div>
        </template>

    </div>
</template>

<script>
import Header from '@/components/layout/Header'

export default {
  name: 'go-to-redsys',
  components: {
    Header
  },
  data () {
    return {
      total: 0,
      payed: 0,
      page: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },
    person () {
      return this.$store.getters['person/getPerson']
    }
  },
  methods: {
    load () {
      this.page = this.$route.name
      var self = this
      this.$store.dispatch('person/loadPersonCampus', { campus_id: this.user.event_id, participant_id: this.user.participant_id }).then(function () {
        self.$store.dispatch('finance/loadBudget', { entity_id: self.person.id, type: 3, event_id: self.user.event_id }).then(function () {
          let budget = self.$store.getters['finance/getBudget']

          self.total = budget.total
          self.payed = budget.payed

          if (self.page === 'confirm-payment' && +budget.total === +budget.payed) {
            self.$router.push({ 'name': 'campus_payments' }).catch()
          }
        })
      })
    },

    goToRedsys () {
      let eventId = this.user.event_id
      let entityType = this.user.entity_type
      let entityId = this.user.participant_id
      window.location = process.env.VUE_APP_API_URL + `finances/${eventId}/redsys/generate/${entityType}/${entityId}?authorization=` + localStorage.token
    }
  },
  created () {
    this.load()
  }
}
</script>

<style lang="scss">
    #go-to-redsys{
        .row {
            margin: 10px 0;
        }
        span {
            font-weight: bold;
            font-size: 16px;
        }
        .mainButton {
            width: 150px !important;
            padding: 0;
            margin: 0;
            height: 100%;
            min-width: 40px;
            outline: none;
            cursor: pointer;
            font-size: 8pt;
            font-family: Speedee-Bold;
            border-radius: 3px;
            border: 1px solid #fc8926;
            text-transform: uppercase;
            background-color: transparent;
            color: #c55c00;
            height: 40px;
            padding: 0;
            font-family: Roboto-Bold;
            font-size: 14px;
            line-height: 14px;
            transition: background-color 0.5s ease;
            float: left;
            &:hover {
              background-color: #fc8a2623 !important;
            }

        }
        .success {
          border: 2px solid #087908;
          border-radius: 5px;
          background-color: #a0f8b6;
          color: #000;
          padding: 10px;
          font-size: 16px;
          text-align: center;
        }

        .message.error {
            background-color: #f73f2061;
            margin: 10px 0;
            border: 2px solid #e61515;
            border-radius: 5px;
            padding: 10px;
            color: #FFF;
            font-weight: bold;
            text-align: center;
        }

    }

</style>
